<template>
  <div>
    <div class="box">
      <blue-title class="style">组织机构代码证</blue-title>
      <div>
        <div class="info" style="height: 70px">
          <span class="marRight">组织机构代码证照片</span
          ><span
            ><el-image
              :src="subjectData.organizationCopy"
              alt=""
              style="width: 58px; height: 58px"
            ></el-image
          ></span>
        </div>
        <div class="info"><span class="marRight">组织机构代码</span><span>{{subjectData.organizationCode}}</span></div>
        <div class="info"><span class="marRight">证件有效期类型</span><span>-----</span></div>
        <div class="info"><span class="marRight">有效期限开始日期</span><span>{{subjectData.orgPeriodBegin}}</span></div>
        <div class="info"><span class="marRight">有效期限结束日期</span><span>{{subjectData.orgPeriodEnd}}</span></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    subjectData: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {};
  },

  watch: {},

  methods: {},
};
</script>

<style lang="less" scoped>
.box {
  background-color: white;
  box-sizing: border-box;
  height: 100%;

  .info {
    display: flex;
    align-items: center;
    font-size: 12px;
    color: #333;
    font-weight: 500;
    height: 42px;
    border-bottom: 1px solid #e5e5e5;
  }
  .style {
    font-size: 12px;
    color: #333;
    font-weight: 500;
    margin: 11px 0 18px 0;
  }
  .marRight {
    width: 100px;
    margin-right: 38px;
  }
}
</style>
